import CityPageTemplate from "../city-template/CityPageTemplate";
import { sacoConfig } from "./data";

export default function SacoPage() {
  return <CityPageTemplate config={sacoConfig} />;
}